const parameterActionTypes = {
  GET_PARAMETERS_START: 'GET_PARAMETERS_START',
  GET_PARAMETERS_SUCCESS: 'GET_PARAMETERS_SUCCESS',
  GET_PARAMETERS_FAILED: 'GET_PARAMETERS_FAILED',
  GET_PARAMETERS_SET_START: 'GET_PARAMETERS_SET_START',
  GET_PARAMETERS_SET_SUCCESS: 'GET_PARAMETERS_SET_SUCCESS',
  GET_PARAMETERS_SET_FAILED: 'GET_PARAMETERS_SET_FAILED',
  SAVE_PARAMETER_START: 'SAVE_PARAMETER_START',
  SAVE_PARAMETER_VALUE_SUCCESS: 'SAVE_PARAMETER_VALUE_SUCCESS',
  SAVE_PARAMETER_VALUE_FAILED: 'SAVE_PARAMETER_VALUE_FAILED',
  SAVE_PARAMETER_SET_START: 'SAVE_PARAMETER_SET_START',
  SAVE_PARAMETER_SET_SUCCESS: 'SAVE_PARAMETER_SET_SUCCESS',
  SAVE_PARAMETER_SET_FAILED: 'SAVE_PARAMETER_SET_FAILED',
  DELETE_PARAMETER_VALUE_START: 'DELETE_PARAMETER_VALUE_START',
  DELETE_PARAMETER_VALUE_SUCCESS: 'DELETE_PARAMETER_VALUE_SUCCESS',
  DELETE_PARAMETER_VALUE_FAILED: 'DELETE_PARAMETER_VALUE_FAILED',
  DELETE_PARAMETER_SET_START: 'DELETE_PARAMETER_SET_START',
  DELETE_PARAMETER_SET_SUCCESS: 'DELETE_PARAMETER_SET_SUCCESS',
  DELETE_PARAMETER_SET_FAILED: 'DELETE_PARAMETER_SET_FAILED',
  SAVE_PARAMETER_OPTION_SUCCESS: 'SAVE_PARAMETER_OPTION_SUCCESS',
  GET_PARAMETER_OPTIONS_START: 'GET_PARAMETER_OPTIONS_START',
  GET_PARAMETER_OPTIONS_SUCCESS: 'GET_PARAMETER_OPTIONS_SUCCESS',
  GET_PARAMETER_OPTIONS_FAILED: 'GET_PARAMETER_OPTIONS_FAILED',
  UPDATE_PARAMETER_OPTIONS_STATE: 'UPDATE_PARAMETER_OPTIONS_STATE',
  REMOVE_PARAMETER_OPTION_FROM_STATE: 'REMOVE_PARAMETER_OPTION_FROM_STATE'
};

export default parameterActionTypes;
